import { Nest } from '~/api/models/Nest';
import { FavoriteFile } from '~/composables/files/useFavorites';
import { BaseModel } from './BaseModel';

export interface EggFirewallRuleEntry {
    protocol?: string;
    action?: string;
    destination_port?: string;
}

export interface EggFirewallFilterEntry {
    filter: string;
    settings: Record<string, unknown>;
}

export interface EggFirewallInfralyConfig {
    rules: EggFirewallRuleEntry[];
    filters: EggFirewallFilterEntry[];
}

export interface EggFirewallConfig {
    infraly?: EggFirewallInfralyConfig;
}

export class Egg extends BaseModel {
    public name = '';
    public tag = '';

    public thumbnail: string | null = null;
    public canUpdate = false;
    public identifier = '';
    public favoriteFiles?: FavoriteFile[];

    // Admin only props
    public id = -1;
    public legacyId: number | null = null;
    public description = '';
    public dockerImages: Record<string, string> = {};
    public startup = '';
    public configFrom?: number;
    public configLogs = '';
    public configFiles = '';
    public configStartup = '';
    public configStop = '';
    public customConfig = '';
    public wispignore = '';
    public firewallConfig: EggFirewallConfig | null = null;

    public scriptInstall = '';
    public scriptIsPrivileged = false;
    public scriptEntry = '';
    public scriptContainer = '';
    public copyScriptFrom?: number;

    public scriptUpdate = '';
    public scriptUpdateIsPrivileged = false;
    public scriptUpdateEntry = '';
    public scriptUpdateContainer = '';
    public copyUpdateScriptFrom?: number;

    public nestId = -1;
    public serversCount?: number;

    public steamJoinButton: number | null = null;
    public steamJoinButtonPort = 0;

    public sourceKey: string | null = null;
    public sourceId: string | null = null;
    public sourceLabel: string | null = null;
    public sourceUrl: string | null = null;
    public sourceViewUrl: string | null = null;
    public sourceHash: string | null = null;
    public sourceSyncedAt: string | null = null;
    public sourceDetached = false;
    public sourceUpdateAvailable = false;

    public exportData: { category?: string } | null = null;
    public canExport = false;

    getRouteName() {
        return 'egg';
    }

    getRouteID() {
        return this.id.toString();
    }

    public get nest(): Nest {
        return this.getRelationship('nest');
    }
}

export enum EggSteamJoinButton {
    DISABLED = 0,
    GAME_PORT = 1,
    GAME_PORT_PLUS_N = 2,
    STATIC_PORT = 3,
}
